import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";
import "./hero.css";

const Hero = memo(({ title, description, heroImage }) => {
	const { i18n } = useTranslation();

	return (
		<section id='hero' className='hero-section'>
			<div className='hero-content md:pt-32 pt-24 flex md:flex-row flex-col-reverse justify-start md:gap-10 gap-5 items-start z-10'>
				<div className='md:w-1/2 w-full z-10'>
					<Fade
						direction={i18n?.language === "ar" ? "right" : "left"}
						triggerOnce={true}>
						<img
							loading='lazy'
							className='rounded-xl'
							src={heroImage}
							alt='Hero Section'
						/>
					</Fade>
				</div>
				<div className='md:text-start text-center md:w-1/2 w-full lg:pt-24 pt-0 z-10'>
					<Fade direction='left' triggerOnce={true}>
						<p className='mt-6 text-3xl md:text-5xl font-semibold text-second_color px-4 mb-5 py-1'>
							{title}
						</p>
					</Fade>
					<div>
						<Fade direction='up' triggerOnce={true}>
							<h1 className='text-white text-[26px] font-normal'>
								{description}
							</h1>
						</Fade>
					</div>
				</div>
			</div>
		</section>
	);
});

export default Hero;
